export default ({color, size}) =>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width={size}>
    <path fill={color} fillRule="evenodd" stroke="none" strokeWidth="1"
          d="M34.41 34.499c3.906-3.905 10.238-3.905 14.143 0l79.903 79.902 79.903-79.902c3.905-3.905 10.237-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142l-79.903 79.903 79.903 79.903c3.834 3.834 3.904 10.008.21 13.927l-.21.215c-3.905 3.906-10.237 3.906-14.142 0l-79.903-79.903-79.903 79.903c-3.905 3.906-10.237 3.906-14.142 0-3.906-3.905-3.906-10.237 0-14.142l79.902-79.903L34.41 48.641c-3.835-3.834-3.904-10.007-.21-13.927Z"/>
  </svg>
;
